import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

const SkeletonListItem = styled(ListItem)(({ theme }) => ({
  color: theme.palette.text.secondaryLight,
  position: 'relative',
  height: '40px',
  paddingLeft: '5px',
  textDecoration: 'none',
  marginBottom: '5px',
  marginTop: '5px',
  '& .MuiListItemIcon-root': {
    minWidth: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const skeletonStyle = {
  bgcolor: 'rgba(255, 255, 255, 0.1)',
  '&::after': {
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
  },
};

const getSkeletonTextWidth = (title = '') => {
  const minWidth = 88;
  const maxWidth = 176;
  const estimatedWidth = title.length * 6.5 + 28;

  return Math.max(minWidth, Math.min(maxWidth, estimatedWidth));
};

function SidebarSkeleton({ drawerOpen, isDualProduct, menuItems }) {
  const renderSkeletonMenuItem = (item) => (
    <SkeletonListItem
      key={`skeleton-row-${item.key}`}
      sx={{
        pointerEvents: 'none',
        '&:hover': {
          backgroundColor: 'transparent',
          color: 'inherit',
        },
      }}
    >
      <ListItemIcon>
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          animation="wave"
          sx={{ ...skeletonStyle, flexShrink: 0 }}
        />
      </ListItemIcon>
      {drawerOpen && (
        <Box sx={{ flexGrow: 1 }}>
          <Skeleton
            variant="rounded"
            width={getSkeletonTextWidth(item.title)}
            height={20}
            animation="wave"
            sx={{ ...skeletonStyle, borderRadius: 1 }}
          />
        </Box>
      )}
    </SkeletonListItem>
  );

  return (
    <Box sx={{ width: '100%' }}>
      {drawerOpen && isDualProduct && (
        <Box px={1} pb={1}>
          <Skeleton
            variant="rounded"
            height={36}
            animation="wave"
            sx={{ ...skeletonStyle, borderRadius: '18px' }}
          />
        </Box>
      )}

      <List sx={{ px: 0, py: 0.5 }}>{menuItems.map((item) => renderSkeletonMenuItem(item))}</List>
    </Box>
  );
}

export default SidebarSkeleton;
